window.BloomRailMount = (root, config, ui) => {
  'use strict';
  const products = config.products;
  const format = (text, values) => text.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');
  let previousBodyOverflow = '';
  const $ = s => root.querySelector(s);
  const track = $('#bloom-track'), stage = $('#bloom-collection'), modal = $('#bloom-editorial');
  const mobile = matchMedia('(max-width:700px)');
  let active = mobile.matches ? 3 : null, currentSize = 0, view = 0, drag = null, suppressClick = false, returnFocus;
  let positions = [], center = 0;
  const nodes = [];
  const el = (tag, cls, text) => { const node = document.createElement(tag); if(cls) node.className=cls; if(text) node.textContent=text; return node; };
  function safeUrl(value) { try { const u=new URL(value); return u.protocol==='https:' ? u.href : null; } catch { return null; } }
  const home = safeUrl(config.shopHome);
  for (const selector of ['#bloom-brand-link','#bloom-back-link']) if(home) $(selector).href=home;
  function placeholder(product, index, asset) {
    const box=el('div','placeholder'); box.style.setProperty('--tone',product.color);
    box.style.setProperty('--asset-ink', ['mocha','burgundy','mocha-croco'].includes(product.id)?'#f5eee4':'#38342f');
    box.append(el('span','asset-index',String(index+1).padStart(2,'0')),el('span','asset-name',product.name),el('span','asset-note',ui.photographAwaited),el('span','asset-path',asset.src));
    return box;
  }
  function visual(product,index,assetIndex=0,important=false,rail=false) {
    const container=el('div','asset'), asset=(rail && product.railImage) || product.images[assetIndex];
    container.dataset.product=product.id;
    if(asset.ready){const img=el('img'); img.alt=asset.alt; img.src=asset.src; if(asset.srcset)img.srcset=asset.srcset; img.sizes=important?'(max-width:700px) 70vw, 440px':'(max-width:700px) 70vw, 210px'; img.loading=important?'eager':'lazy'; img.decoding='async'; img.draggable=false; img.addEventListener('error',()=>container.replaceChildren(placeholder(product,index,asset)),{once:true}); container.append(img);}
    else container.append(placeholder(product,index,asset));
    return container;
  }
  products.forEach((p,i)=>{
    const button=el('button','hanging');button.setAttribute('aria-label',format(ui.selectProduct,{name:p.name}));button.append(visual(p,i,0,i===3,true));
    button.addEventListener('click',()=>{if(suppressClick)return;if(mobile.matches && active===i)openEditorial();else select(i);});
    track.append(button);nodes.push(button);
    const swatch=el('button','swatch');swatch.style.setProperty('--tone',p.color);swatch.setAttribute('aria-label',p.name);swatch.addEventListener('click',()=>select(i));$('#bloom-color-nav').append(swatch);
  });
  // THE RAIL 2.3: one continuous circular move, no multi-step waiting.
  // Desktop geometry is periodic; mobile keeps the original one-bag swipe.
  function metrics() {
    const w = stage.clientWidth;
    const item = nodes[0].offsetWidth;
    const sideMargin = Math.min(60, Math.max(24, w * .035));
    const materialGap = mobile.matches ? 0 : Math.min(24, Math.max(12, w * .012));
    const step = mobile.matches
      ? item + 34
      : (w - 2 * sideMargin - item - materialGap) / (products.length - 1);
    const materialBreak = products.findIndex(p => p.id === 'mocha-croco');
    positions = products.map((p, i) => i * step + (mobile.matches
      ? 0
      : (p.offset || 0) + (materialBreak >= 0 && i >= materialBreak ? materialGap : 0)));
    return { w, item, step };
  }
  const slot = (index, selected) => {
    const n = products.length;
    let s = (index - selected + n) % n;
    if (s > Math.floor(n / 2)) s -= n;
    return s;
  };
  function layout(extra = 0) {
    const { w, item, step } = metrics();
    if (!w || !item) return;
    const base = (w - item) / 2;
    const overview = (positions[0] + positions[products.length - 1]) / 2;
    const target = active === null ? overview : positions[active];
    center = base - target;
    // The desktop rail is stationary: only the hanging items move.
    track.style.transform = mobile.matches
      ? `translate3d(${center + extra}px,0,0)`
      : 'translate3d(0,0,0)';
    nodes.forEach((button, i) => {
      const focus = active === i;
      const x = mobile.matches
        ? positions[i]
        : (active === null
          ? positions[i] + base - overview
          : base + slot(i, active) * step);
      button.style.left = `${x}px`;
      button.style.transform = `rotate(${products[i].tilt}deg) scale(${focus ? (mobile.matches ? 1.09 : 1.16) : 1})`;
      button.style.opacity = active !== null && !focus
        ? (mobile.matches ? '.5' : '.72') : '1';
      button.style.zIndex = focus ? '4' : '1';
      button.setAttribute('aria-pressed', String(focus));
    });
  }
  function sizeSelector(product){
    const field=el('fieldset','sizes');const legend=el('legend','sr-only',ui.laptopSize);field.append(legend);
    if(!product.sizes.length)field.hidden=true;
    product.sizes.forEach((size,i)=>{const button=el('button','size',size.label);button.setAttribute('aria-pressed',String(i===currentSize));button.addEventListener('click',()=>{currentSize=i;root.querySelectorAll('.sizes').forEach(group=>group.querySelectorAll('button').forEach((b,j)=>b.setAttribute('aria-pressed',String(j===i))));updateShop();});field.append(button);});return field;
  }
  function renderFocus(){
    const focused=active!==null;$('#bloom-intro').hidden=focused;$('#bloom-product-focus').hidden=!focused;$('#bloom-reset').hidden=!focused;
    root.querySelectorAll('.swatch').forEach((s,i)=>s.setAttribute('aria-pressed',String(active===i)));
    $('#bloom-counter').textContent=`${String((active??0)+1).padStart(2,'0')} — ${String(products.length).padStart(2,'0')}`;
    if(!focused)return;
    const p=products[active], box=$('#bloom-product-focus');box.replaceChildren(el('h2','',p.name.toUpperCase()),el('p','',p.productType),sizeSelector(p));
    const explore=el('button','explore',ui.explore);explore.append(el('span','','→'));explore.addEventListener('click',openEditorial);box.append(explore);
  }
  // Animate a direct selection in one motion. Wrap-around bags use a
  // visual twin exiting one side while the real bag enters the other.
  const RAIL_MS = 560;
  let railMoving = false;
  let pendingRailTarget = null;
  let railAnimations = [];
  let railClones = [];
  let railGeneration = 0;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  function cancelRailMotion() {
    railGeneration++;
    railAnimations.forEach(animation => animation.cancel());
    railClones.forEach(clone => clone.remove());
    railAnimations = [];
    railClones = [];
    pendingRailTarget = null;
    railMoving = false;
  }
  function select(index) {
    const n = products.length;
    const target = Math.max(0, Math.min(n - 1, index));
    if (mobile.matches || reducedMotion.matches || !stage.clientWidth) {
      cancelRailMotion();
      active = target;
      renderFocus();
      layout();
      return;
    }
    // When somebody changes their mind mid-animation, retain only their
    // latest choice. There are never intermediate forced selection steps.
    if (railMoving) {
      pendingRailTarget = target;
      return;
    }
    if (active === target) return;

    const oldIndex = active === null ? Math.floor(n / 2) : active;
    const oldActive = active;
    const oldPositions = nodes.map(button => parseFloat(button.style.left) || 0);
    const { step } = metrics();
    const oldTransform = products.map((p, i) =>
      `rotate(${p.tilt}deg) scale(${oldActive === i ? 1.16 : 1})`);
    const oldOpacity = products.map((_, i) => oldActive !== null && oldActive !== i ? .72 : 1);
    let direction = (target - oldIndex + n) % n;
    if (direction > Math.floor(n / 2)) direction -= n;
    const shift = -direction * step;

    active = target;
    renderFocus();
    layout();
    const newPositions = nodes.map(button => parseFloat(button.style.left));

    railMoving = true;
    const generation = ++railGeneration;
    const options = { duration: RAIL_MS, easing: 'cubic-bezier(.22,.8,.25,1)', fill: 'both' };
    const animations = [];
    const clones = [];

    nodes.forEach((button, i) => {
      const oldX = oldPositions[i];
      const newX = newPositions[i];
      const nextTransform = `rotate(${products[i].tilt}deg) scale(${target === i ? 1.16 : 1})`;
      const nextOpacity = target === i ? 1 : .72;
      // Crossing a periodic edge would make the product fly across all seven
      // bags. Animate a clone out and its real counterpart in instead.
      const wrapped = Math.abs((oldX + shift) - newX) > step * 3.5;
      const fromX = wrapped ? newX - shift : oldX;
      if (wrapped) {
        const clone = button.cloneNode(true);
        clone.classList.add('bloom-rail-ghost');
        clone.setAttribute('aria-hidden', 'true');
        clone.tabIndex = -1;
        clone.style.left = `${oldX}px`;
        clone.style.transform = oldTransform[i];
        clone.style.opacity = String(oldOpacity[i]);
        clone.style.zIndex = oldActive === i ? '4' : '1';
        track.append(clone);
        clones.push(clone);
        animations.push(clone.animate([
          { left: `${oldX}px`, transform: oldTransform[i], opacity: oldOpacity[i] },
          { left: `${oldX + shift}px`, transform: oldTransform[i], opacity: oldOpacity[i] }
        ], options));
      }
      animations.push(button.animate([
        { left: `${fromX}px`, transform: oldTransform[i], opacity: oldOpacity[i] },
        { left: `${newX}px`, transform: nextTransform, opacity: nextOpacity }
      ], options));
    });

    railAnimations = animations;
    railClones = clones;
    Promise.all(animations.map(a => a.finished.catch(() => {}))).then(() => {
      if (generation !== railGeneration) return;
      animations.forEach(a => a.cancel());
      clones.forEach(clone => clone.remove());
      railAnimations = [];
      railClones = [];
      railMoving = false;
      const queued = pendingRailTarget;
      pendingRailTarget = null;
      if (queued !== null && queued !== active) select(queued);
    });
  }
  $('#bloom-reset').addEventListener('click',()=>{cancelRailMotion();active=null;renderFocus();layout();});
  function updateShop(){
    if(!modal.open)return;
    const p=products[active], size=p.sizes[currentSize], link=$('#bloom-shop-link'), note=$('#bloom-shop-note');
    const reference=size && p.products?.[size.id];
    const url=config.commerceEnabled===true && reference && size.shopifyUrl===reference.url
      ? window.BloomRailProductUrl?.(size.shopifyUrl) : null;
    if(url){link.href=url;link.removeAttribute('aria-disabled');link.removeAttribute('tabindex');note.textContent=format(ui.continueToShop,{name:p.sizes[currentSize]?.label || p.name});}
    else{link.removeAttribute('href');link.setAttribute('aria-disabled','true');link.setAttribute('tabindex','-1');note.replaceChildren(document.createTextNode(ui.missingLink + ' '));const back=el('a','',ui.mainShop);if(home)back.href=home;note.append(back);}
  }
  function renderView(){const p=products[active];if(!p.images.length){$('#bloom-editorial-image').replaceChildren();$('#bloom-views').replaceChildren();return;}$('#bloom-editorial-image').replaceChildren(visual(p,active,view,true));$('#bloom-views').replaceChildren();p.images.forEach((asset,i)=>{const b=el('button','',ui.views[asset.view] || asset.view);b.setAttribute('aria-pressed',String(view===i));b.addEventListener('click',()=>{view=i;renderView();$('#bloom-views').children[i].focus({preventScroll:true});});$('#bloom-views').append(b);});}
  function openEditorial(){
    if(active===null || modal.open)return;returnFocus=document.activeElement;const p=products[active];
    view=Math.max(0,p.images.findIndex(asset=>asset.view==='front'));
    if(!Number.isInteger(currentSize) || currentSize<0 || currentSize>=p.sizes.length)currentSize=0;
    modal.dataset.product=p.id;
    $('#bloom-editorial-number').textContent=format(ui.productPosition,{current:String(active+1).padStart(2,'0'),total:String(products.length).padStart(2,'0')});
    const copy=$('#bloom-editorial-copy');copy.replaceChildren(el('p','eyebrow',p.collectionLabel || ui.suedeCollection));const title=el('h2','',p.name);title.id='bloom-editorial-title';copy.append(title,el('p','product-type',p.productType),...(p.story?[el('p','story',p.story)]:[]),sizeSelector(p));
    if(p.details.length){const details=el('ul','details');p.details.forEach(t=>details.append(el('li','',t)));copy.append(details);}
    const shop=el('a','shop-link',ui.viewInShop);shop.id='bloom-shop-link';shop.append(el('span','','→'));const note=el('p','shop-note');note.id='bloom-shop-note';copy.append(shop,note);
    renderView();modal.showModal();modal.scrollTop=0;previousBodyOverflow=document.body.style.overflow;document.body.style.overflow='hidden';updateShop();$('#bloom-close-modal').focus({preventScroll:true});
  }
  $('#bloom-close-modal').addEventListener('click',()=>modal.close());
  modal.addEventListener('close',()=>{document.body.style.overflow=previousBodyOverflow;if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});});
  stage.addEventListener('pointerdown',e=>{if(e.button!==0)return;drag={id:e.pointerId,start:e.clientX,delta:0,moved:false};suppressClick=false;});
  stage.addEventListener('pointermove',e=>{if(!drag||drag.id!==e.pointerId)return;drag.delta=e.clientX-drag.start;if(Math.abs(drag.delta)>7){drag.moved=true;stage.setPointerCapture(e.pointerId);stage.classList.add('dragging');if(mobile.matches)layout(drag.delta*.82);}});
  function finish(e,cancel=false){if(!drag||drag.id!==e.pointerId)return;const state=drag;drag=null;stage.classList.remove('dragging');suppressClick=state.moved;if(state.moved&&!cancel){const step=positions[1]-positions[0];const from=active??3;const move=Math.abs(state.delta)>35?Math.max(1,Math.round(Math.abs(state.delta)/step)):0;const count=products.length;const next=mobile.matches?Math.max(0,Math.min(count-1,from-Math.sign(state.delta)*move)):(from-Math.sign(state.delta)*move+count*10)%count;select(next);}else if(mobile.matches)layout();if(stage.hasPointerCapture(e.pointerId))stage.releasePointerCapture(e.pointerId);setTimeout(()=>{suppressClick=false;},0);}
  stage.addEventListener('pointerup',e=>finish(e));stage.addEventListener('pointercancel',e=>finish(e,true));
  root.addEventListener('keydown',e=>{if(modal.open)return;if(!['ArrowLeft','ArrowRight','Home','End','Escape'].includes(e.key))return;if(e.target.closest('.sizes'))return;e.preventDefault();if(e.key==='Escape'){if(!mobile.matches){cancelRailMotion();active=null;renderFocus();layout();}return;}const count=products.length;const selected=e.key==='Home'?0:e.key==='End'?count-1:mobile.matches?Math.max(0,Math.min(count-1,(active??3)+(e.key==='ArrowRight'?1:-1))):((active??3)+(e.key==='ArrowRight'?1:-1)+count)%count;select(selected);nodes[selected].focus({preventScroll:true});});
  let resizeFrame;new ResizeObserver(()=>{cancelAnimationFrame(resizeFrame);resizeFrame=requestAnimationFrame(()=>{cancelRailMotion();if(mobile.matches&&active===null){active=3;renderFocus();}layout();});}).observe(stage);
  renderFocus();layout();
};
